import "./navbar.css";
function Navbar() {
    return ( 
        <header className="header-logo">
<img className="logo" src="/assets/images/Atlas-CafeRestaurant.png" alt="لوگو کافه رستوران اطلس"></img>
        </header>
     );
}

export default Navbar;